import { render, staticRenderFns } from "./top2.vue?vue&type=template&id=b3d0bb94&"
import script from "./top2.vue?vue&type=script&lang=js&"
export * from "./top2.vue?vue&type=script&lang=js&"
import style0 from "./top2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports